import styled from "@emotion/styled";
import { Skeleton } from "@mui/material";

export const StyledItemsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    marginTop: theme.spacing(3),
}));

export const StyledItemContainer = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(2),
}));

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
}));
